<mat-card class="deadlines-card">
  <h3 class="card-title">{{ title }}</h3>

  <div class="deadlines-container">
    @for (item of items(); track $index) {
      <div class="deadline-item">
        <!-- Текст -->
        <div class="deadline-text">
          <div class="deadline-info">{{ cleanDeadlineInfo(item.info) }}</div>
          <div class="deadline-status">
            @if (item.passed) {
              <span>{{ 'dashboard.deadlinePassed' | translate }}</span>
            } @else {
              <span>{{ 'dashboard.daysRemaining' | translate }} {{ item.days }} {{ pluralDays(item.days) }}</span>
            }
          </div>
        </div>

        <!-- Бар -->
        <div class="progress-bar-wrap">
          <div
            class="progress-bar-fill"
            [style.width.%]="getProgressPercent(item.days, item.passed)">
          </div>

          <!-- Текст на баре -->
          <div class="progress-bar-label">
            @if (item.passed) {
              {{ 'dashboard.deadlinePassed' | translate }}
            } @else {
              {{ item.days }} {{ pluralDays(item.days) }}
            }
          </div>
        </div>
      </div>
    }
  </div>
</mat-card>
